import React from 'react'

import { Banner, Icon, Text } from '@driftt/dds'
import { faCircleInfo } from '@driftt/dds.icons/solid/faCircleInfo'


const ScoringInProgressBanner = ({ onClose }: { onClose: () => void}) => {
  return (
    <Banner.Root variant="info" onClose={onClose}>
    <Banner.Content>
      <Icon icon={faCircleInfo} color="blue6"/>
      <Text>
        An admin has modified your ICP in Drift. 
        It may take up to 24 hours to generate account fit scores.
      </Text>
    </Banner.Content>
  </Banner.Root>
  )
}

export default ScoringInProgressBanner
